// const API_BASE_URL = "http://localhost:8000"; 
const API_BASE_URL = "https://teest.ru/api"


export async function createOutlineKey(user_id, username, days) {
  const body = {
    user_id: String(user_id),
    username: String(username), 
    days: Number(days),
  };

  const response = await fetch(`${API_BASE_URL}/outline/create_key/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorData = await response.json();
    console.error('Ошибка от сервера:', errorData);
    throw new Error(errorData.detail?.[0]?.msg || 'Ошибка запроса');
  }

  return response.json();
}



export async function createVlessKey(user_id, username, days) {
  const body = {
    user_id: String(user_id),
    username: String(username), 
    days: Number(days),
  };

  const response = await fetch(`${API_BASE_URL}/vless/create_key/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorData = await response.json();
    console.error('Ошибка от сервера:', errorData);
    throw new Error(errorData.detail?.[0]?.msg || 'Ошибка запроса');
  }

  return response.json();
}




export async function createObhodKey(user_id, username, days) {
  const body = {
    user_id: String(user_id),
    username: String(username), 
    days: Number(days),
  };

  const response = await fetch(`${API_BASE_URL}/obhod/create_key/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorData = await response.json();
    console.error('Ошибка от сервера:', errorData);
    throw new Error(errorData.detail?.[0]?.msg || 'Ошибка запроса');
  }

  return response.json();
}



export async function getSubscriptionStatus(user_id){
  const response = await fetch(`${API_BASE_URL}/subscribe/${user_id}`);
  return response.json();
}



export async function checkTrial(user_id, table_name){
  const response = await fetch(`${API_BASE_URL}/checkTrial/${user_id}/${table_name}`);
  return response.json();
}

export async function createPayment(telegram_id, username, amount, service) {
  const body = {
    telegram_id: Number(telegram_id),
    username: String(username || "NoUsername"),
    amount: Number(amount),
    service: service,  // 'outline', 'vless' или 'obhod'
  };

  const response = await fetch(`${API_BASE_URL}/payment/pay`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorData = await response.json();
    console.error('Ошибка создания платежа:', errorData);
    throw new Error(errorData.detail || 'Ошибка создания платежа');
  }

  return response.json(); 
}

export async function createPlategaPay(telegram_id, username, amount, service) {
  const body = {
    telegram_id: Number(telegram_id),
    username: String(username || "NoUsername"),
    amount: Number(amount),
    service: service,  // 'outline', 'vless' или 'obhod'
  };

  const response = await fetch(`${API_BASE_URL}/platega/create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorData = await response.json();
    console.error('Ошибка создания платежа:', errorData);
    throw new Error(errorData.detail || 'Ошибка создания платежа');
  }

  return response.json(); 
}


export async function activateOutlinePromo(user_id, kod) {
  const body = {
    user_id: Number(user_id),
    kod: String(kod).trim(),
  };

  const response = await fetch(`${API_BASE_URL}/promokod/outline_promokod/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorData = await response.json();
    console.error('Ошибка активации промокода Outline:', errorData);
    throw new Error(errorData.detail || 'Ошибка активации промокода');
  }

  return response.json();
}

export async function activateVlessPromo(user_id, kod) {
  const body = {
    user_id: Number(user_id),
    kod: String(kod).trim(),
  };

  const response = await fetch(`${API_BASE_URL}/promokod/vless_promokod/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorData = await response.json();
    console.error('Ошибка активации промокода Vless:', errorData);
    throw new Error(errorData.detail || 'Ошибка активации промокода');
  }

  return response.json();
}

export async function activateObhodPromo(user_id, kod) {
  const body = {
    user_id: Number(user_id),
    kod: String(kod).trim(),
  };

  const response = await fetch(`${API_BASE_URL}/promokod/obhod_promokod/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorData = await response.json();
    console.error('Ошибка активации промокода Obhod:', errorData);
    throw new Error(errorData.detail || 'Ошибка активации промокода');
  }

  return response.json();
}


export async function checkUserAuthorization(user_id) {
  if (!user_id) {
    return { present: false };
  }

  try {
    const response = await fetch(`${API_BASE_URL}/check-id/${user_id}`);

    if (!response.ok) {
      console.error('Ошибка проверки авторизации:', response.status);
      return { present: false };
    }

    const data = await response.json();
    return data; // { present: true } или { present: false }
  } catch (error) {
    console.error('Не удалось проверить авторизацию:', error);
    return { present: false };
  }
}

export async function getReffCount(user_id){
  const response = await fetch(`${API_BASE_URL}/referral-count/${user_id}`);
  return response.json();
}

export async function getAllReffCount(){
  const response = await fetch(`${API_BASE_URL}/all_referral`);
  return response.json();
}


export async function getPartnerCount(user_id){
  const response = await fetch(`${API_BASE_URL}/partner-count/${user_id}`);
  return response.json();
}



export async function requestWithdrawal(telegram_id, card_number, name, bank_name) {
  const body = {
    card_number,
    name,
    bank_name,
  };

  const response = await fetch(`${API_BASE_URL}/vivod/${telegram_id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    console.error('Ошибка вывода:', errorData);
    throw new Error(errorData.detail || 'Не удалось создать заявку на вывод');
  }

  return response.json();
}

export async function getPartnerIds(user_id){
  const response = await fetch(`${API_BASE_URL}/partner_id/${user_id}`);
  return response.json();
}

export async function getLastVivod(user_id){
  const response = await fetch(`${API_BASE_URL}/vivod/last/${user_id}`);
  return response.json();
}


export async function getUser(user_id){
  const response = await fetch(`${API_BASE_URL}/users/${user_id}`);
  return response.json();
}

export async function getCountDevices(username){
  const response = await fetch(`${API_BASE_URL}/users/${username}/devices`);
  return response.json();
}

export async function deleteDevice(username, deviceId){
  const response = await fetch(`${API_BASE_URL}/users/${username}/devices/${deviceId}`, {
    method: 'DELETE',
  });
  return response.json();
}

export async function renewSubscription(telegram_id) {
  const response = await fetch(`${API_BASE_URL}/renew-subscription?telegram_id=${telegram_id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || `Ошибка ${response.status}`);
  }

  return response.text();
}